export const SEND_QUOTE_TO_CUSTOMER_FORM_NAME = 'Send Quote To Customer';
export const CUSTOMERS_SELECTED_TEXT = 'Customers Selected';
export const SUMMARY_AND_PAYMENT_FORM_LOCATION = 'Summary and Payment';
export const SUMMARY_AND_PAYMENT_CREATE_QUOTE = 'Create Quote';
export const PLACE_ORDER_FORM_NAME = 'Place Order';
export const PENDING_QUOTE_DETAILS = 'Pending Quote Details';
export const PURCHASE_ORDER_NUMBER = 'Purchase Order Number';
export const PO_CHANGED = 'PO Changed';
export const PO_NOT_CHANGED = 'PO Not Changed';
export const PCC_ESPOT_SUMMARY_AND_PAYMENT_PAY_NOW =
  'PCC_ESPOT_SUMMARY_AND_PAYMENT_PAY_NOW';
